/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_How_CalfInputs */

const en_us2_body_measures_how_calf = /** @type {(inputs: Body_Measures_How_CalfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Around the thickest part of the calf. Standing, weight on both legs.`)
};

const pt_br2_body_measures_how_calf = /** @type {(inputs: Body_Measures_How_CalfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na parte mais grossa da panturrilha. Em pé, peso distribuído nas duas pernas.`)
};

const es_419_body_measures_how_calf = /** @type {(inputs: Body_Measures_How_CalfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En la parte más gruesa de la pantorrilla. De pie, con el peso repartido en ambas piernas.`)
};

const pt_pt2_body_measures_how_calf = /** @type {(inputs: Body_Measures_How_CalfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na parte mais grossa da barriga da perna. De pé, peso distribuído pelas duas pernas.`)
};

const fr_fr2_body_measures_how_calf = /** @type {(inputs: Body_Measures_How_CalfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Au plus épais du mollet. Debout, poids réparti sur les deux jambes.`)
};

const de_de2_body_measures_how_calf = /** @type {(inputs: Body_Measures_How_CalfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An der dicksten Stelle der Wade. Im Stehen, Gewicht auf beiden Beinen.`)
};

const it_it2_body_measures_how_calf = /** @type {(inputs: Body_Measures_How_CalfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nel punto più spesso del polpaccio. In piedi, peso su entrambe le gambe.`)
};

/**
* | output |
* | --- |
* | "Around the thickest part of the calf. Standing, weight on both legs." |
*
* @param {Body_Measures_How_CalfInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_how_calf = /** @type {((inputs?: Body_Measures_How_CalfInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_How_CalfInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_how_calf(inputs)
	if (locale === "es-419") return es_419_body_measures_how_calf(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_how_calf(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_how_calf(inputs)
	if (locale === "de-DE") return de_de2_body_measures_how_calf(inputs)
	if (locale === "it-IT") return it_it2_body_measures_how_calf(inputs)
	return en_us2_body_measures_how_calf(inputs)
});
export { body_measures_how_calf as "body-measures.how_calf" }